<template>
  <label
    :class="classes">
    <span
      class="ui-search-input__icon"
      @click="emitState('search')" />
    <input
      ref="input"
      :value="value"
      class="ui-search-input__input"
      type="search"
      inputmode="search"
      :placeholder="placeholder"
      autocomplete="off"
      @keypress.enter="emitState('enter')"
      @focus="emitState('focus')"
      @input="setSearchValue">
    <span
      class="ui-search-input__close transition--opacity"
      @click.prevent="emitState('clear')" />
  </label>
</template>

<script>
export default {
  name: 'UiSearchInput',

  props: {
    value: {
      type: [String, Number],
      required: true,
    },

    placeholder: {
      type: String,
      default: null,
    },

    size: {
      type: String,
      default: 'medium',
      validate: (value) => ['extra-small', 'small', 'medium'].includes(value),
    },
  },

  computed: {
    classes() {
      return [
        'ui-search-input',
        `ui-search-input--${this.size}`,
        {
          'ui-search-input--active': this.value.length,
        },
      ];
    },
  },

  methods: {
    setSearchValue(event) {
      this.$emit('input', event.target.value.trim());
    },

    emitState(state) {
      this.$emit(state);

      if (state === 'clear') {
        this.$emit('input', '');
        this.$refs.input.focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .ui-search-input {
    //--background-color: #{$color--basic-dark-gray}
    //--font-color: #{$color--basic-light-gray}

    position: relative;
    border-radius: 40px;
    display: flex;
    background-color: var(--background-color, $color--basic-dark-gray);
    align-items: center;
    padding: 0 20px;
    opacity: 0.55;
    transition: 0.3s;
  }

  .ui-search-input--active {
    opacity: 1;

    .ui-search-input__close {
      opacity: 1;
      pointer-events: auto;
      visibility: visible;
    }
  }

  .ui-search-input__input {
    font-family: inherit;
    font-size: 13px;
    line-height: 40px;
    border: none;
    font-weight: 500;
    color: var(--font-color, $color--basic-light-gray);
    background: none;
    outline: none;
    flex: 1;
    padding: 0;
    transition: transform var(--transition-color-time) ease-out;
    margin: 0 16px;

    &::placeholder {
      color: var(--font-color, $color--basic-light-gray);
      font-weight: 500;
      font-size: 13px;
    }
  }

  .ui-search-input__icon {
    -webkit-mask-image: url(/images/icons/search.svg);
    mask-image: url(/images/icons/search.svg);
    -webkit-mask-size: cover;
    mask-size: cover;
    background-color: var(--font-color, $color--basic-light-gray);
    width: 16px;
    height: 16px;
    cursor: pointer;
    flex-shrink: 0;
  }

  .ui-search-input__close {
    -webkit-mask-image: url(/images/icons/exit.svg);
    mask-image: url(/images/icons/exit.svg);
    -webkit-mask-size: cover;
    mask-size: cover;
    background-color: var(--font-color, $color--basic-light-gray);
    width: 16px;
    height: 16px;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    cursor: pointer;
  }

  .ui-search-input--extra-small {
    padding: 0 12px;

    .ui-search-input__input {
      line-height: 32px;
      font-size: 13px;

      &::placeholder {
        font-size: 13px;
      }
    }
  }

  .ui-search-input--small {
    padding: 0 16px;

    .ui-search-input__input {
      line-height: 40px;
      font-size: 13px;

      &::placeholder {
          font-size: 13px;
      }
    }
  }

  @media screen and #{$screen-more-or-1280} {
    .ui-search-input__input {
      line-height: 48px;
      font-size: 15px;

      &::placeholder {
        font-size: 15px;
      }
    }
  }

  @media screen and #{$screen-less-than-1280} {
    .ui-search-input--small {
      .ui-search-input__input {
        margin: 0 8px;
      }
    }
  }
</style>
